import React from 'react'
import { LinkProps, NavLink as RouterNavLink } from 'react-router-dom'

const NavLink = React.forwardRef<LinkProps, any>((props, ref) => (
  <RouterNavLink innerRef={ref} {...props} />
))

export default NavLink
